import React from 'react';

const LeftFill = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 17" {...props}>
    <path fill="#3E3E40" d="M8 0L0 8.5 8 17V0z" />
  </svg>
);

export default LeftFill;
